import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  fetchEquiposCortesia,
  fetchEquiposLogisticaDetalle,
} from "../../../../actions";
import formatMoney from "../../../../utils/formatMoney";

//<I-89405_L_Corrección equipos adicionales>
const Adicionales = (props) => (
  <section className="fdv-section tab-pane active" id="adicionales">
    <header className="fdv-section-head">
      <h5 className="fdv-section-title">Equipos adicionales de cortesia</h5>
    </header>
    <div className="tableWrapper">
      <table className="table table-hover">
        <thead className="table-head">
          <tr>
            <th>SKU</th>
            <th>Adicional</th>
            <th>Cantidad</th>
            <th>Precio</th>
          </tr>
        </thead>
        <tbody>
          {props.Adicionales.map((entity) => (
            <tr
              className="as"
              data-toggle="collapse"
              data-target="#pedidoFact0"
              aria-expanded="false"
              aria-controls="col"
            >
              <td>{entity.numPedidoVeh}</td>
              <td>{entity.descEquipo}</td>
              <td>{entity.cantidad}</td>
              <td>US${formatMoney(entity.precio * entity.cantidad)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
);

const AdicionalesProforma = (props) => (
  <section className="fdv-section tab-pane active" id="adicionales">
    <header className="fdv-section-head">
      <h5 className="fdv-section-title">Equipos adicionales de Proforma</h5>
    </header>
    <div className="tableWrapper">
      <table className="table table-hover">
        <thead className="table-head">
          <tr>
            <th>SKU</th>
            <th>Detalle</th>
            <th>Precio Unit.</th>
            <th>Cantidad</th>
            <th>Precio Total</th>
            <th>Tipo</th>
          </tr>
        </thead>
        <tbody>
          {props.equipoAdicionalLocalList.map((data, id) => (
            <tr key={id}>
              <td>{props.sku}</td>
              <td>{data.descEquipo}</td>
              <td>{data.precio}</td>
              <td>{data.cantidad}</td>
              <td>{data.total}</td>
              <td>Adicionales Locales</td>
            </tr>
          ))}
          {props.equipoAdicionalEspecialList.map((data, id) => (
            <tr key={id}>
              <td>{props.sku}</td>
              <td>{data.descEquipo}</td>
              <td>{data.precio}</td>
              <td>{data.cantidad}</td>
              <td>{data.total}</td>
              <td>Adicionales Especiales</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
);
//<F-89405_L_Corrección equipos adicionales>

class TabAdicionales extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaAdicionales: [],
      equipoAdicionalLocalList: [],
      equipoAdicionalEspecialList: [],
      equipoAdicionalOtroList: [],
      dataVehiculo: [],
      proveedorEquposAdicionalesModalOpen: [],
    };
  }

  componentDidMount() {
    this.setState({ listaAdicionales: [] });
    this.props.fetchEquiposCortesia(this.props.fdvID);

    this.props
      .fetchEquiposLogisticaDetalle(this.props.selectProforma, "", "", 0, 0)
      .then((result) => {
        console.log(result.payload.data);
        this.setState({
          equipoAdicionalLocalList:
            result.payload.data.equipoAdicionalLocalList,
          equipoAdicionalEspecialList:
            result.payload.data.equipoAdicionalEspecialList,
          equipoAdicionalOtroList: result.payload.data.equipoAdicionalOtroList,
          dataVehiculo: result.payload.data.dataVehiculo,
          proveedorEquposAdicionalesModalOpen: false,
        });
        console.log(this.state.equipoAdicionalLocalList);
        console.log(this.state.equipoAdicionalEspecialList);
        console.log(this.state.equipoAdicionalOtroList);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  render() {
    return (
      <div>
        {this.state.equipoAdicionalLocalList &&
        this.state.equipoAdicionalLocalList.length === 0 &&
        this.state.equipoAdicionalEspecialList &&
        this.state.equipoAdicionalEspecialList.length === 0 ? (
          <div className="tableWrapper">
            <table className="table table-hover ">
              <tr>
                <td>
                  {" "}
                  <p style={{ textAling: "center" }}>
                    El pedido no tiene, equipos adicionales !!
                  </p>
                </td>
              </tr>
            </table>
          </div>
        ) : (
          <AdicionalesProforma
            equipoAdicionalLocalList={this.state.equipoAdicionalLocalList}
            equipoAdicionalEspecialList={this.state.equipoAdicionalEspecialList}
          />
        )}

        {this.props.equipoAdicionalOtroList &&
        this.props.equipoAdicionalOtroList.length === 0 ? (
          <div className="tableWrapper">
            <table className="table table-hover ">
              <tr>
                <td>
                  {" "}
                  <p style={{ textAling: "center" }}>
                    El pedido no tiene, equipos adicionales !!
                  </p>
                </td>
              </tr>
            </table>
          </div>
        ) : (
          <Adicionales Adicionales={this.state.equipoAdicionalOtroList} />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    equiposCortesia: state.equiposCortesia,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    fetchEquiposCortesia,
    fetchEquiposLogisticaDetalle,
  })(TabAdicionales)
);



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/ItemsDetalle/Adicionales.js